{
  "identity": {
    "title": "Identité"
  },
  "status": {
    "title": "Statut"
  },
  "lastUpdate": {
    "title": "Dernière mise à jour"
  },
  "profile": {
    "title": "Profil"
  },
  "group": {
    "title": "Groupe"
  },
  "state": {
    "title": "État"
  },
  "name": {
    "title": "Nom"
  },
  "operations": {
    "title": "Opérations"
  },
  "connectionParameters": {
    "title": "Paramètres de connexion"
  },
  "specificParameters": {
    "title": "Paramètres spécifiques"
  },
  "roles": {
    "title": "Permissions"
  }
}
